<template>
  <div class="header">
    <div class="headTop">
      <div class="container clearfix">
        <h2>欢迎来到CERM项目平台</h2>
        <div class="userInfo">
          <div v-if="!$store.getters.token">
            <router-link to="/login">登录</router-link>
            <router-link to="/login?type=register">注册</router-link>
          </div>
          <div v-if="$store.getters.token">
            <router-link class="username" to="/center">
              <img
                :src="$store.getters.userInfo.avatar || require('../../assets/images/public/avatar.png')"
              />
              {{ $store.getters.userInfo.chineseName }}
            </router-link>
            <span @click="logout">
              <el-button :loading="logoutLoading" type="text">退出</el-button>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="banner"></div>
    <nav>
      <div class="container">
        <ul>
          <li>
            <router-link :class="{'active' : active == 1}" to="/">网站首页</router-link>
          </li>
          <li>
            <router-link :class="{'active' : active == 2}" to="/center">个人中心</router-link>
          </li>
          <li>
            <router-link :class="{'active' : active == 4}" to="/aboutCertificates">关于证书</router-link>
          </li>
          <li>
            <router-link :class="{'active' : active == 5}" to="/examinationAccreditation">考试认证</router-link>
          </li>
          <li>
            <router-link :class="{'active' : active == 3}" to="/examinationAccredita">学习专栏</router-link>
          </li>
          <li>
            <router-link :class="{'active' : active == 7}" to="/examinationNotice">考试公告</router-link>
          </li>
          <li>
            <router-link :class="{'active' : active == 6}" to="/referenceMaterial">资料下载</router-link>
          </li>
          <li>
            <router-link :class="{'active' : active == 8}" to="/about">关于我们</router-link>
          </li>
        </ul>
      </div>
    </nav>
    <!-- <div class="container">
            <router-link to="/">Home</router-link> |
            <router-link to="/about">About</router-link> |
            <router-link to="/list">带缓存列表测试</router-link>
            <h1>这是页头</h1>

            <h4>
                {{ $store.getters }}
                
            </h4>
    </div>-->
  </div>
</template>

<script>
import { getToken, removeToken } from "@/utils/auth";
export default {
  name: "myHeader",
  data() {
    return {
      logoutLoading: false
    };
  },
  props: {
    active: {
      type: String,
      default: ""
    }
  },
  methods: {
    async logout() {
      this.logoutLoading = true;
      await this.$store.dispatch("logout");
      this.logoutLoading = false;
      this.$router.push(`/`);
    }
  }
};
</script>

<style scoped>
.header {
  position: relative;
  width: 1200px;
  margin: 0 auto;
}
.headTop {
  position: absolute;
  left: 0;
  top: 0;
  height: 50px;
  line-height: 50px;
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
}
.userInfo {
  float: right;
  margin-right: 23px;
}
.headTop h2 {
  font-size: 14px;
  color: #fff;
  float: left;
  margin-left: 23px;
}
.banner {
  height: 365px;
  background: #a42b23 url(../../assets/images/public/banner.png) no-repeat
    center center;
  background-size: 100% 100%;
  width: 1200px;
}
nav {
  height: 54px;
  background: #a92d21;
  border: 1px solid #f48013;
  border-top: 0;
  background: -webkit-linear-gradient(#c1381e, #902225);
  background: -o-linear-gradient(#c1381e, #902225);
  background: -moz-linear-gradient(#c1381e, #902225);
  background: linear-gradient(#c1381e, #902225);
}
nav ul li {
  display: inline-block;
  width: 150px;
  height: 54px;
  line-height: 54px;
  text-align: center;
  background: url(../../assets/images/public/nav_line.png) no-repeat right
    center;
}
nav ul li:last-child {
  background: none;
}
nav ul li a {
  display: block;
  width: 100%;
  height: 100%;
  font-size: 18px;
  color: #fff;
}
nav ul li a:hover {
  background: url(../../assets/images/public/nav_active.png) no-repeat center
    center;
}
nav ul li a.active {
  background: url(../../assets/images/public/nav_active.png) no-repeat center
    center;
}
.userInfo a {
  font-size: 14px;
  color: #fff;
}
.userInfo div a:first-child {
  margin-right: 30px;
}
.username img {
  width: 30px;
  height: 30px;
  border-radius: 15px;
  margin-bottom: -11px;
  margin-right: 4px;
}

.userInfo >>> .el-button--text {
  color: #fff;
}
.userInfo >>> .el-button.is-loading:before {
  display: none;
}
</style>